<template>
    <div :id="mapJson.mapName" style="width: 100%;height:100%;background-color: rgba(4, 49, 100, .6)"></div>
</template>

<script>
import * as echarts from 'echarts'
import {_pxGenerator} from "./MapFunction";
import EmCommonApi from "@/mixin/em/common/api";
import {_generateCpOfGeoMap, _getMapJson} from "@/components/LayoutMaps/maps/EChartsMap";
import {mapState} from "vuex";

export default {
    name: "TheMap",
    mixins: [EmCommonApi],
    props: {
        mapCode: String
    },
    data() {
        return {
            mapJson: {},
            chart: {},
            options: {},
            regions: [],
        }
    },
    computed: {
        ...mapState({
            mapData: state => state.kpiLayout.mapData,
            filters: state => state.kpiLayout.filter
        })
    },
    watch: {
        filters() {
            this.initMapData(this.filters);
        }
    },
    mounted() {
        this.mapJson = _generateCpOfGeoMap(_getMapJson(this.mapCode));
        this.$nextTick(() => {
            this.initChartMap();
            this.loading();
        });
        window.addEventListener('resize', this.resetOption, false)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.resetOption, false)
        if (this.chart) {
            this.chart.dispose();
            this.chart = null;
        }
    },
    methods: {
        resetOption() {
            this.options = {
                tooltip: {
                    show: true,
                    formatter: function (item) {
                        if (item.data != null && item.data.type === '1') {
                            let val = item.data;
                            return '区域名称： ' + val.label + val.projectCodes + val.workers + val.stopTasks + val.tasks + val.toDoOperations;
                        }
                        return null;
                    },
                    confine: true,
                    appendToBody: true
                },
                visualMap: {
                    show: false,
                    type: 'piecewise',
                    min: 1,
                    max: 3,
                    pieces: [
                        {value: 0, color: '#b0b0b0'},//非工位区域
                        {value: 1, color: '#53d445'},//在岗
                        {value: 2, color: '#c8c800'},//黄灯
                        {value: 3, color: '#d00000'},//红灯
                        {value: 4, color: '#808080'},//离岗
                        {value: 5, color: '#808080'},//离岗 & 有任务
                    ]
                },
                geo: {
                    map: this.mapJson.mapName,
                    roam: false,//鼠标缩放和平移 都不开启
                    zoom: 1.15,//当前视角缩放比例
                    label: {
                        normal: {
                            show: true,
                            position: 'insideTopLeft',
                            formatter: (item) => {
                                for (let d of this.mapData) {
                                    if (item.name === d.name) {
                                        if (d.type === '0') {
                                            return '{normalName|' + d.label + '}';
                                        } else if (d.value === 2 || d.value === 3) {
                                            return '{budget|' + d.label + '}';
                                        } else if (d.value === 5) {
                                            return '{markedName|' + d.label + '}';
                                        } else {
                                            return '{name|' + d.label + '}';
                                        }
                                    }
                                }
                                return '{normalName|' + item.name + '}'
                            },
                            rich: {
                                budget: {
                                    fontSize: _pxGenerator(0.16),
                                    lineHeight: 30,
                                    color: 'yellow'
                                },
                                name: {
                                    fontSize: _pxGenerator(0.12),
                                    color: '#fff'
                                },
                                normalName: {
                                    fontSize: _pxGenerator(0.12),
                                    color: '#000'
                                },
                                markedName: {
                                    fontSize: _pxGenerator(0.12),
                                    fontWeight: 'bold',
                                    color: '#50fa7b'
                                }
                            }
                        }
                    },
                    itemStyle: {
                        normal: {
                            color: '#53d445',
                            borderColor: 'rgba(0 ,0 ,0 , 0.2)'
                        },
                        emphasis: {//高亮状态下。。
                            areaColor: '#cb42f5',
                            shadowOffsetX: 0,
                            shadowOffsetY: 0,
                            shadowBlur: 20,//阴影模糊大小
                            borderWidth: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    },
                    regions: this.regions
                },
                series: [{
                    type: 'map',
                    geoIndex: 0,
                    data: this.mapData
                }]
            }
            this.chart.setOption(this.options)
        },
        initChartMap() {
            echarts.registerMap(this.mapJson.mapName, this.mapJson)
            this.chart = echarts.init(document.getElementById(this.mapJson.mapName))
            this.resetOption();
        },
        loading() {
            this.chart.showLoading({
                text: 'loading',
                color: '#cb42f5',
                textColor: '#fff',
                maskColor: 'rgba(0, 0, 0, 0.4)'
            })
        },
        initMapData(filter) {
            for (let area of filter) {
                this.regions.push({
                    name: area,
                    itemStyle: {
                        areaColor: '#b0b0b0',
                        emphasis: {
                            areaColor: '#b0b0b0',
                            shadowBlur: 0
                        }
                    }
                })
            }
            this.resetOption()
            this.chart.resize()
            this.chart.hideLoading()
        }
    }
}
</script>

<style scoped>

</style>
